export default "__VITE_PUBLIC_ASSET__59d6d716__"